import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { ClientRegisteredVendor } from './client-registered-vendor';
import { ExemptVendor } from './exempt-vendor';
import { SubNationalDivision } from './sub-national-division';
import { Vendor } from './vendor';

export class VendorTradeState extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static VendorTradeStateProperties: (
    | {
        property: keyof VendorTradeState;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof VendorTradeState;
        type: 'alias';
      }
    | {
        property: keyof VendorTradeState;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'SubNationalDivisionId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    { property: 'ExemptVendor', model: 'ExemptVendor', type: 'association' },
    {
      property: 'ClientRegisteredVendor',
      model: 'ClientRegisteredVendor',
      type: 'association'
    },
    {
      property: 'SubNationalDivision',
      model: 'SubNationalDivision',
      type: 'association'
    }
  ];

  static {
    VendorTradeState.VendorTradeStateProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        VendorTradeState.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        VendorTradeState.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        VendorTradeState.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(VendorTradeStateObject: Partial<VendorTradeState>) {
    super();

    VendorTradeState.VendorTradeStateProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = VendorTradeStateObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number | null;
  VendorId?: number | null;
  ExemptVendorId?: number | null;
  ClientRegisteredVendorId?: number | null;
  SubNationalDivisionId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  Vendor?: Vendor;
  ExemptVendor?: ExemptVendor;
  ClientRegisteredVendor?: ClientRegisteredVendor;
  SubNationalDivision?: SubNationalDivision;
}
